/**
 * Endpoint for updating assignment data
 *
 * Copyright (C) 2018D Noom, Inc.
 * @author hubert
 */

import _ from "lodash";
import axios from "axios";

import { Api } from "@noom/noomscape";
import { getAuthorizationHeader } from "@noom/hive-auth";

Api.register("assignmentsUpdate", ({ cduAccessCode, data }) => {
  return axios({
    url: `/assignmentRotations/cdus/${cduAccessCode}`,
    baseURL: process.env.HIVE_SERVER_URL,
    method: "PUT",
    data: data,
    headers: {
      Authorization: getAuthorizationHeader(),
      "Content-Type": "application/json",
    },
  })
    .then((response) => "ok")
    .catch((error) => {
      console.log("ASSIGNMENTS UPDATE ERROR", error);
      throw error;
    });
});
